import React from "react";

const Section = ({ id, title, children }) => (
  <section id={id} className="scroll-mt-24">
    <h2 className="font-display text-2xl font-bold text-[#2C3E50] mb-3 pl-4 border-l-4 border-[#F39C12]">
      {title}
    </h2>
    <div className="text-[#2C3E50]/90 leading-relaxed space-y-3 text-[15px]">
      {children}
    </div>
  </section>
);

const LegalLayout = ({ title, eyebrow, lastUpdated, nav, children }) => {
  return (
    <div className="font-body">
      <section className="bg-[#FBF7F0] py-14 border-b border-[#F39C12]/15">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm uppercase tracking-[0.2em] text-[#D63031] font-semibold mb-3">
            {eyebrow}
          </p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-[#2C3E50]">
            {title}
          </h1>
          <p className="mt-3 text-sm text-[#7F8C8D]">
            Last updated: {lastUpdated}
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10">
          <aside className="lg:col-span-3 order-2 lg:order-1">
            <div className="lg:sticky lg:top-24 bg-white rounded-2xl border border-[#F39C12]/20 p-5">
              <p className="font-display text-sm font-semibold text-[#2C3E50] mb-3 uppercase tracking-wide">
                Jump to
              </p>
              <ul className="space-y-2 text-sm">
                {nav.map((n) => (
                  <li key={n.id}>
                    <a
                      href={`#${n.id}`}
                      className="text-[#2C3E50]/80 hover:text-[#D63031]"
                    >
                      {n.label}
                    </a>
                  </li>
                ))}
              </ul>
              <a
                href="#top"
                className="mt-5 inline-block text-xs text-[#F39C12] font-semibold"
              >
                ↑ Back to top
              </a>
            </div>
          </aside>
          <div className="lg:col-span-9 order-1 lg:order-2 space-y-8" id="top">
            {children}
          </div>
        </div>
      </section>
    </div>
  );
};

LegalLayout.Section = Section;
export default LegalLayout;
